import { Component, Input, OnInit } from '@angular/core';
import { texts } from '../activity-item.texts';

@Component({
  standalone: false,
  selector: 'sc-activity-item-project-analysis-created',
  templateUrl: './activity-item-project-analysis-created.component.html',
  styleUrls: ['./activity-item-project-analysis-created.component.scss']
})
export class ActivityItemProjectAnalysisCreatedComponent implements OnInit {

  @Input()
  activity : any;

  @Input()
  condensed = false;

  @Input()
  showProjectName = false;

  @Input()
  language: 'de' | 'en' = 'de';

  texts = texts;

  constructor() { }

  ngOnInit(): void {
  }

  // the payload carries a snapshot of the analysis as it was when it was created
  get matchCount() {
    return this.activity?.Payload?.Analysis?.EstimatedTotalMatches;
  }

}
